'use client'

import {
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material'

const TeamSearchInput = ({
  searchQuery,
  onSearchChange,
  onClear,
  isSearching,
}) => {
  return (
    <div className="tw:flex tw:justify-center">
      <TextField
        size="small"
        placeholder="Search team member..."
        variant="outlined"
        value={searchQuery}
        onChange={onSearchChange}
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '9999px',
            backgroundColor: '#f5f5f5',
            '& fieldset': {
              borderColor: 'transparent',
            },
            '&:hover fieldset': {
              borderColor: '#e0e0e0',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0e0e0',
              borderWidth: '1px',
            },
          },
          '& .MuiOutlinedInput-input::placeholder': {
            fontStyle: 'italic',
            opacity: 0.7,
          },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <i className="far fa-search tw:text-neutral-400" />
              </InputAdornment>
            ),
            endAdornment: isSearching ? (
              <InputAdornment position="end">
                <CircularProgress size={18} />
              </InputAdornment>
            ) : searchQuery ? (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={onClear}
                  aria-label="Clear search"
                >
                  <i className="far fa-times tw:text-neutral-400 tw:text-sm" />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
      />
    </div>
  )
}

export default TeamSearchInput
